import * as actionActions from './action.actions';

export interface State {
  searchTerm: string;
  searchMonth: string;
  searchDay: string;
}

const initialState: State = {
  searchTerm: '',
  searchMonth: '',
  searchDay: '',
};

export function reducer(state = initialState, action: actionActions.All): State {
  switch (action.type) {
    case actionActions.SEARCH:
      return Object.assign({}, state, { searchTerm: action.payload });

    case actionActions.SEARCH_BY_MONTH:
      return Object.assign({}, state, { searchMonth: action.payload });

    case actionActions.SEARCH_BY_DAY:
      return Object.assign({}, state, { searchDay: action.payload });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/store/action/action.reducer.ts